import MyStorage from "./storage";
/**
 *
 * @param {import('aws-amplify')} amplify
 * @param {*} organization
 * @param {*} domain
 * @param {*} secure
 */
function configureAmplify(amplify, organization, domain, secure) {
  console.log("SETTING UP DOMAIN", domain);
  console.log("Setup", {
    userPoolId: organization.signInConfig.userPoolId,
    userPoolWebClientId: organization.signInConfig.userPoolWebClientId
  });
  amplify.configure({
    storage: MyStorage,
    Auth: {
      oauth: organization.signInConfig.oauth,
      region: organization.signInConfig.region,
      userPoolId: organization.signInConfig.userPoolId,
      userPoolWebClientId: organization.signInConfig.userPoolWebClientId,
      mandatorySignIn: false
      // cookieStorage: {
      //   // REQUIRED - Cookie domain (only required if cookieStorage is provided)
      //   domain: domain,
      //   // OPTIONAL - Cookie path
      //   path: "/",
      //   // OPTIONAL - Cookie expiration in days
      //   expires: 30,
      //   // OPTIONAL - Cookie secure flag
      //   // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
      //   secure: secure
      // }
    }
  });
  return true;
}
export default configureAmplify;
